import {
  streamBankBalances as grpcStreamBankBalances,
  cancelBankBalanceStream as grpcCancelBankBalanceStream
} from '@/streams/account'
import type { Coin } from '@injectivelabs/ts-types'

export const cancelBankBalanceStream = grpcCancelBankBalanceStream

export const streamBankBalance = () => {
  const bankStore = useBankStore()
  const sharedWalletStore = useSharedWalletStore()

  if (!sharedWalletStore.injectiveAddress) {
    return
  }

  grpcStreamBankBalances({
    accountAddress: sharedWalletStore.injectiveAddress,
    callback: ({ amount, denom }) => {
      const bankBalancesExcludingDenom = bankStore.bankBalances.filter(
        (balance: Coin) => balance.denom !== denom
      )

      bankStore.$patch({
        bankBalances: [...bankBalancesExcludingDenom, { denom, amount }]
      })
    }
  })
}
